<template>
  <div class="invoice-qualification section-body">
    <el-form :model="formData" label-width="160px" size="small" ref="invoiceQualityForm" :rules="rules">
      <template v-if="invoiceType == InvoiceType.SPECIAL || invoiceType == InvoiceType.DIGITAL_SPECIAL">
        <el-form-item label="专票资质状态:">
          <span>{{statusInfo.name}}<i class="status-icon" :class="statusInfo.icon"></i></span><el-button type="text" v-show="status == qualifStatus.Ok.value && !isEdit" @click="editQuality">修改</el-button>
          <p v-show="status == qualifStatus.Fail.value && specialInvoice && specialInvoice.checkRemark">驳回理由：{{specialInvoice && specialInvoice.checkRemark}}</p>
        </el-form-item>
        <el-form-item label="公司名称:" prop="companyName">
          <span>{{formData.companyName}}</span>
        </el-form-item>
        <el-form-item label="纳税人识别号:" prop="taxpayerNum">
          <el-input v-if="isEdit" v-model="formData.taxpayerNum" placeholder="请输入纳税人识别号"></el-input>
          <span v-else>{{formData.taxpayerNum}}</span>
        </el-form-item>
        <el-form-item label="公司注册地址:" prop="companyAddress">
          <el-input v-if="isEdit" v-model="formData.companyAddress" placeholder="请输入公司注册地址"></el-input>
          <span v-else>{{formData.companyAddress}}</span>
        </el-form-item>
        <el-form-item label="公司注册电话:" prop="telNum">
          <el-input v-if="isEdit" v-model="formData.telNum" placeholder="请输入加区号的公司注册电话"></el-input>
          <span v-else>{{formData.telNum}}</span>
        </el-form-item>
        <el-form-item label="开户银行:" prop="bankName">
          <el-input v-if="isEdit" v-model="formData.bankName" placeholder="请输入与开户许可证一致的银行名称"></el-input>
          <span v-else>{{formData.bankName}}</span>
        </el-form-item>
        <el-form-item label="银行账号:" prop="bankAccount">
          <el-input v-if="isEdit" v-model="formData.bankAccount" placeholder="请输入银行账号"></el-input>
          <span v-else>{{formData.bankAccount}}</span>
        </el-form-item>
        <el-form-item label="营业执照:" prop="businessLicenseUrl">
          <quality-img v-if="isEdit" v-model="formData.businessLicenseUrl" desc="请提交带二维码的新版营业执照扫描件 " @change="changeImage('existingBusinessLicenseUrl')"></quality-img>
          <span v-else>
            <span v-if="!formData.businessLicenseUrl">未上传</span>
            <a v-else :href="'/img/' + formData.businessLicenseUrl" target="_blank">查看原图</a>
          </span>
        </el-form-item>
        <el-form-item label="开户许可证:" prop="bankPermitUrl">
          <quality-img v-if="isEdit" v-model="formData.bankPermitUrl" @change="changeImage('existingBankPermitUrl')"></quality-img>
          <span v-else>
            <span v-if="!formData.bankPermitUrl">未上传</span>
            <a v-else :href="'/img/' + formData.bankPermitUrl" target="_blank">查看原图</a>
          </span>
        </el-form-item>
        <el-form-item label="税务登记证:" prop="taxPicUrl">
          <quality-img v-if="isEdit" v-model="formData.taxPicUrl" @change="changeImage('existingTaxPicUrl')"></quality-img>
          <span v-else>
            <span v-if="!formData.taxPicUrl">未上传</span>
            <a v-else :href="'/img/' + formData.taxPicUrl" target="_blank">查看原图</a>
          </span>
        </el-form-item>
        <el-form-item label="一般纳税资格证:" prop="taxpayerCertificateUrl">
          <quality-img v-if="isEdit" v-model="formData.taxpayerCertificateUrl" @change="changeImage('existingTaxpayerCertificateUrl')"></quality-img>
          <span v-else>
            <span v-if="!formData.taxpayerCertificateUrl">未上传</span>
            <a v-else :href="'/img/' + formData.taxpayerCertificateUrl" target="_blank">查看原图</a>
          </span>
        </el-form-item>
        <el-form-item v-show="isEdit">
          <el-button type="primary" style="width: 100px;" @click="subimt">提交</el-button>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="纳税人识别号(税务登记证号):" prop="taxId" label-width="240px">
          <p>&nbsp;{{taxId}}</p>
          <p class="invoice-mk"><i class="el-icon-warning"></i>纳税人识别号取自账户资质中“税务登记证号”，如需添加/修改，前往账户资质中心，直接修改税务登记证号即可；账户在通过状态下，修改税务登记证号不会触发审核，修改完点击提交按钮立即生效。</p>
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>
<script>
  import {qualifStatus, InvoiceType} from '../utils/consts.js';
  import {saveInvoiceQualification} from '../utils/api.js';
  import QualityImg from './quality-img.vue';
  export default {
    name: 'invoice-qualification',
    props: {
      specialInvoice: Object,
      invoiceType: [Number, String],
      taxId: [String, Number]
    },
    data() {
      return {
        isEdit: false,
        status: '',
        formData: {
          companyName: '',
          taxpayerNum: '',
          companyAddress: '',
          telNum: '',
          bankName: '',
          bankAccount: '',
          businessLicenseUrl: '',
          bankPermitUrl: '',
          taxPicUrl: '',
          taxpayerCertificateUrl: ''
        },
        exist: {
          existingTaxPicUrl: '',
          existingBankPermitUrl: '',
          existingTaxpayerCertificateUrl: '',
          existingBusinessLicenseUrl: ''
        },
        rules: {
          taxpayerNum: {required: true, message: '纳税人识别号不能为空', trigger: 'blur'},
          companyAddress: {required: true, message: '公司注册地址不能为空', trigger: 'blur'},
          telNum: {required: true, message: '公司注册电话不能为空', trigger: 'blur'},
          bankName: {required: true, message: '开户银行不能为空', trigger: 'blur'},
          bankAccount: {required: true, message: '银行账号不能为空', trigger: 'blur'},
          businessLicenseUrl: {required: true, message: '请正确上传有年检章(二维码)的企业营业执照副本扫描件', trigger: 'blur'},
          bankPermitUrl: {required: true, message: '请上传开户许可证', trigger: 'blur'},
          taxpayerCertificateUrl: {required: true, message: '请上传一般纳税资格证', trigger: 'blur'},
        },
        qualifStatus,
        InvoiceType
      }
    },
    computed: {
      statusInfo() {
        if (this.status) {
          return Object.values(qualifStatus).find(it => it.value == this.status) || {};
        }
        return {};
      }
    },
    watch: {
      specialInvoice(v) {
        if (!v) return;
        this.status = v.status;
        for (let key in this.formData) {
          this.formData[key] = v[key];
        }
        this.exist.existingTaxPicUrl = v.taxPicUrl;
        this.exist.existingBankPermitUrl = v.bankPermitUrl;
        this.exist.existingTaxpayerCertificateUrl = v.taxpayerCertificateUrl;
        this.exist.existingBusinessLicenseUrl = v.businessLicenseUrl;

        this.isEdit = [qualifStatus.NotUpload.value, qualifStatus.Fail.value].includes(this.status);
      }
    },
    components: {
      QualityImg
    },
    methods: {
      editQuality() {
        this.isEdit = true;
      },
      subimt() {
        this.$refs.invoiceQualityForm.validate(async valid => {
          if (!valid) return;
          let form = new FormData();
          for (let k in this.formData) {
            form.append(k, this.formData[k]);
          }
          form.append('vatQuaId', this.specialInvoice.id || 0);
          if (this.specialInvoice.id) {
            for (let k in this.exist) {
              form.append(k, this.exist[k]);
            }
          }
          const result = await saveInvoiceQualification(form);
          if (result) {
            this.$message.success('提交成功');
            this.$emit('edit');
          }
        });
      },
      changeImage(key) {
        this.exist[key] = '';
      }
    }
  }
</script>
<style lang="scss">
  .invoice-qualification {
    .invoice-mk {
      width: 500px;
      line-height: 1.4;
      color: #999;
      font-size: 12px;
      .el-icon-warning {
        color: #67C23A;
      }
    }
    .status-icon {
      display: inline-block;
      margin: 0 6px 0 2px;
      &.color-brand {
        color: #409EFF;
      }
      &.color-success {
        color: #67C23A;
      }
      &.color-warning {
        color: #E6A23C;
      }
      &.color-error {
        color: #F56C6C;
      }
    }
  }
</style>